/**
 * Customer packages: the Packages card on a customer's page - the session
 * packages they bought and what is left on each.
 * Conventions: see `common.ts`.
 */
const customerPackages: Record<string, string> = {
  title: 'Packages',
  description: 'Session packages this customer bought, and what is left on each.',
  loading: 'Loading packages…',
  load_failed: 'Could not load this customer’s packages.',
  empty: 'No packages yet.',
  sessions_left: '{left} of {total} sessions left',
  expires: 'Use by {date}',
  no_expiry: 'No expiry',
  purchased: 'Bought {date}',
  price_paid: 'Paid {amount}',

  'status.awaiting_payment': 'Awaiting payment',
  'status.active': 'Active',
  'status.exhausted': 'Used up',
  'status.expired': 'Expired',
  'status.cancelled': 'Cancelled',
  'status.refunded': 'Refunded',
};

export default customerPackages;
